<template>
  <naj-box :title="local.guardianForm.title">
    <v-row>
      <v-col
        cols="12"
        lg="2"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.guardianForm.minorTypeId"
          :value.sync="formModel.minorTypeId"
          :disabled="viewMode"
          :items="minorCases"
          item-text="name"
          item-value="id"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.guardianForm.relativeTypeId"
          :value.sync="formModel.relativeTypeId"
          :disabled="viewMode"
          :items="relatives"
          item-text="name"
          item-value="id"
          :validates="`required|isVerified:${isRelativeTypeValid}`"
        ></naj-input>
      </v-col>
      <v-col
        v-if="showGuardianshipNumber"
        cols="12"
        lg="2"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.guardianForm.guardianshipNumber"
          :value.sync="formModel.guardianshipNumber"
          :validates="`required|long|max:14|isValid:${local.guardianForm.invalidNumber},${isNumberValid}|isVerified:${formModel.isVerified || formModel.isManualDeed}`"
          :disabled="viewMode"
          @input="changesGuardianshipNumber()"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.isManualDeed || (showGuardianshipNumber && isCheckingFailed)"
        cols="12"
        lg="1"
      >
        <naj-input
          class="align-checkbox-with-input"
          :type-id="formFieldType.checkbox"
          :label="local.guardianForm.isManualDeed"
          :value.sync="formModel.isManualDeed"
          :disabled="viewMode"
        ></naj-input>
      </v-col>
      <v-col
        v-if="showGuardianshipNumber && !formModel.isVerified && !formModel.isManualDeed"
        cols="12"
        lg="1"
        class="align-self-center"
      >
        <naj-button
          square
          inputs-alignment
          :loading="isChecking"
          :disabled="!isCheckingValidityValid"
          @click="validateGuardianshipNumber"
        >
          {{ local.common.check }}
        </naj-button>
      </v-col>

      <v-col
        v-if="showRelationshipCheck"
        cols="12"
        lg="1"
        class="align-self-center"
      >
        <naj-button
          square
          inputs-alignment
          :loading="isChecking"
          :disabled="!isCheckingRelationValidityValid"
          @click="validateFamilyRelationShip"
        >
          {{ local.common.check }}
        </naj-button>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { minorTypes, relativesTypes } from '@/helpers/enum.js';

const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  inject: ['$validator'],
  props: ['formModel', 'guardianSocialId', 'viewMode', 'guardianBirthDate'],
  data() {
    return {
      isChecking: false,
      isChecked: false,
    };
  },
  created() {
    this.getMinorCases();
    this.getRelatives();
  },
  computed: {
    ...mapLUTState(['minorCases', 'relatives']),
    isCheckingValidityValid() {
      return this.formModel.guardianshipNumber && this.guardianSocialId && this.formModel.socialId;
    },
    isCheckingRelationValidityValid() {
      return this.formModel.relativeTypeId == relativesTypes.father && this.guardianSocialId && this.formModel.socialId;
    },
    isNumberValid() {
      return this.formModel.guardianshipNumber !== 0;
    },
    isRelativeTypeValid() {
      return !this.showRelationshipCheck || this.formModel.isVerified || this.formModel.minorTypeId == minorTypes.mentalDisability;
    },
    showGuardianshipNumber() {
      return !(this.formModel.relativeTypeId == relativesTypes.father && this.formModel.minorTypeId == minorTypes.underage);
    },
    showRelationshipCheck() {
      return (this.formModel.relativeTypeId == relativesTypes.father && this.formModel.minorTypeId == minorTypes.underage);
    },
    isCheckingFailed() {
      return this.isChecked && !this.formModel.isVerified;
    },
  },
  methods: {
    ...mapLUTActions(['getMinorCases', 'getRelatives']),
    ...mapSysActions(['validateGuardianship', 'getMOIFamilyRelation']),
    validateGuardianshipNumber() {
      this.isChecking = true;
      this.validateGuardianship({
        guardianshipNumber: this.formModel.guardianshipNumber,
        guardianSocialId: this.guardianSocialId,
        minorSocialId: this.formModel.socialId,
      })
        .then(() => {
          this.toaster.success(this.local.common.verificationSucceeded, 2);
          this.changeVerification(true);
        })
        .catch(() => {
          this.toaster.error(`${this.local.guardianForm.title} غير صحيحة`);
          this.changeVerification(false);
        })
        .finally(() => {
          this.isChecking = false;
          this.isChecked = true;
        });
    },
    changeVerification(isVerified) {
      this.$set(this.formModel, 'isVerified', isVerified);
    },
    changesGuardianshipNumber() {
      this.changeVerification(false);
      this.isChecked = false;
    },
    validateFamilyRelationShip() {
      this.isChecking = true;
      var payload = {
        socialId: this.formModel.socialId,
        dateOfBirth: this.formModel.dateOfBirth,
        subSocialId: this.guardianSocialId,
        subDateOfBirth: this.guardianBirthDate,
      };
      this.getMOIFamilyRelation(payload)
        .then(() => {
          this.toaster.success(this.local.common.verificationSucceeded, 2);
          this.changeVerification(true);
        })
        .catch(() => {
          this.toaster.error(`${this.local.guardianForm.invalidRelation}`);
          this.changeVerification(false);
        })
        .finally(() => (this.isChecking = false));
    },
  },
  watch: {
    showGuardianshipNumber(value) {
      if (!value)
        this.$set(this.formModel, 'guardianshipNumber', null);
    },
  },
};
</script>
